module.exports = __webpack_public_path__ + "img/2.e9f9c9e8.jpg";